import { ToolDocument } from "@app/tool/model/toolDocument.model";

export class ToolDocuments {

    public isDocumentationComplete: boolean;
    public toolDocuments: ToolDocument[];
    public hasRootPath: boolean;
    constructor(documents: any = {}) {
        this.isDocumentationComplete = documents.isDocumentationComplete;
        this.toolDocuments = documents.toolDocuments;
        this.hasRootPath = documents.hasRootPath;
    }

    get type() {
        return "tool-documents";
    }
}
